import * as yup from 'yup'

const baseSchema = {
  restUrlIdList: yup.array()
  .required().min(1, 'At least one restaurant must be selected'),
  // .test(
  //   'matchValue', 
  //   (val) => `${val.value} is not match`, 
  //   value => value && value.trim() === 'test'
  // ),
  versionConfigList: yup.array().required().min(1, 'At least one version config must be provided'),
  deviceType: yup.string(),
  buildTarget: yup.string(),
  shopAppReleaseId: yup.string(),
  forceUpdate: yup.boolean(),
}

const createSchema = yup.object().shape({
  ...baseSchema,
  // status not required for create in original code
})

const editSchema = yup.object().shape({
  ...baseSchema,
})

function formatYupError(err) {
  const map = {}
  if (!err || !err.inner) return map
  err.inner.forEach((e) => {
    const path = e.path || '_global'
    if (!map[path]) map[path] = []
    if (!map[path].includes(e.message)) map[path].push(e.message)
  })
  return map
}

export async function validateForm(data, mode) {
  const schema = mode ? editSchema : createSchema
  try {
    await schema.validate(data, { abortEarly: false })
    return { valid: true, errors: {} }
  } catch (err) {
    return { valid: false, errors: formatYupError(err) }
  }
}
